import { Directive } from 'vue';
import popImg from '@/assets/img/svg/default-pop-img.svg';

const isImage = (url:string) => {
  return (url.match(/\.(jpeg|jpg|gif|png｜svg)$/) != null);
};
export const defaultImg: Directive = {
  mounted(el, binding) {
    el.onerror = () => {
      if (binding.value && isImage(binding.value)) {
        el.src = binding.value;
      } else {
        el.src = 'https://s3.ap-northeast-1.amazonaws.com/s3.toobit.com/images/default-img.png';
      }
    };
  }
};

export const defaultPopImg: Directive = {
  mounted(el, binding) {
    el.onerror = () => {
      if (binding.value && isImage(binding.value)) {
        el.src = binding.value;
      } else {
        el.src = popImg;
      }
    };
  }
};
